<template>
    <div>
        <slot name="loading" v-if="loading">
            <loader-icon class="h-5 w-5"/>
        </slot>
        <slot v-else-if="!loading && error" name="error" :error="error">
            {{ $t('dataloader.error') }}
        </slot>
        <slot v-else :result="result"></slot>
    </div>
</template>
<script>
import LoaderIcon from './icons/Loader'

export default {
    components: {
        LoaderIcon
    },
    props: {
        url: {
            required: true,
            type: String
        }
    },
    data() {
        return {
            loading: true,
            result: null,
            error: null,
        }
    },
    mounted() {
        this.loadData()
    },
    methods: {
        async loadData() {
            return axios.get(this.url).then(({data}) => {
                this.result = data;
            }).catch(({response}) => {
                this.error = response.data;
            }).finally(() => {
                this.loading = false;
            })
        }
    }
}
</script>
